import { UserRoles } from 'applicaiton/constants/userRoles';
import { getUserRole } from 'applicaiton/sessionStorage/auth';

/**
 * Checks if a given user role exactly matches the user roles stored in session storage.
 *
 * @param userType - The user role to check for an exact match against the stored user roles.
 * @returns A boolean value indicating whether the provided user role exactly matches any of the stored user roles.
 */
export const userRoleExactMatch = (userType: UserRoles) => {
  const userRole = getUserRole();

  return userRole?.split(',').some((item) => item === userType);
};
